import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountStatusCard = ({
  tier,
  creditsRemaining,
  totalAnalyses = 0,
  bestMatchScore = 0,
  trackedSkills = 0,
  totalCreditsUsed = 0,
  onUpgrade
}) => {
  const isPremium = tier === 'premium';
  const scansLeft = typeof creditsRemaining === 'number' ? creditsRemaining : 0;

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-card-foreground">Account status</h3>
        <span
          className={`px-3 py-1 rounded-full text-sm font-medium ${isPremium ? 'bg-accent text-accent-foreground' : 'bg-warning text-warning-foreground'
            }`}
        >
          {isPremium ? 'Premium' : 'Free plan'}
        </span>
      </div>

      <div className="bg-muted rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Remaining scans</p>
            <p className="text-2xl font-semibold text-foreground">{scansLeft}</p>
          </div>
          {!isPremium && (
            <Button size="sm" variant="default" onClick={onUpgrade} iconName="Crown" iconPosition="left">
              Upgrade
            </Button>
          )}
        </div>
        {!isPremium && (
          <p className="text-xs text-muted-foreground mt-2">
            Free plan includes 1 complimentary scan. Upgrade for more.
          </p>
        )}
        {isPremium && scansLeft === 0 && (
          <p className="text-xs text-warning mt-2">
            You've used all premium scans. Purchase again to add +2 scans.
          </p>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
        <div className="p-3 bg-muted/50 rounded-lg">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Total analyses</p>
          <p className="text-lg font-semibold text-foreground">{totalAnalyses}</p>
        </div>
        <div className="p-3 bg-muted/50 rounded-lg">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Best match score</p>
          <p className="text-lg font-semibold text-foreground">{Math.round(bestMatchScore)}%</p>
        </div>
        <div className="p-3 bg-muted/50 rounded-lg sm:col-span-2">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Total credits used (incl. free)</p>
          <p className="text-lg font-semibold text-foreground">{totalCreditsUsed}</p>
        </div>
      </div>

      {isPremium ? (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground text-center">
            Premium top-ups add 2 scans per purchase.
          </p>
          {scansLeft <= 1 && (
            <Button
              variant="default"
              onClick={onUpgrade}
              iconName="CreditCard"
              iconPosition="left"
              fullWidth
            >
              💳 Buy 2 Credits
            </Button>
          )}
        </div>
      ) : (
        <div className="text-center">
          <Button
            variant="default"
            onClick={onUpgrade}
            iconName="Crown"
            iconPosition="left"
            fullWidth
            className="mt-2"
          >
            Unlock premium features
          </Button>
        </div>
      )}
    </div>
  );
};

export default AccountStatusCard;